import { toast } from 'react-toastify';

const cartMiddleware = store => next => action => {
    const actionsToBeChecked = [
        'counter/setSelectedNVR',
        'counter/updateNVRQuantity2',
        'counter/setSelectedCamera',
        'counter/updateCamera2',
        'counter/setSelectedCabling',
        'counter/updateCables2',
        'counter/setSelectedLabor',
        'counter/updateLabour2',
        'counter/setSelectedSpecial',
        'counter/updateSpecial2',
        'counter/setSelectedPoE',
        'counter/updateSwitch2',
        'counter/setSelectedHardWare',
        'counter/updateHardware2',
    ];

    // Check if the action type indicates adding a product to any part of the state
    if (actionsToBeChecked.includes(action.type)) {
        const state = store.getState();
        const { totalNoOptions } = state.counter1; // Assuming 'counter' slice is where this is managed

        // Check if 'totalNoOptions' is defined and greater than zero
        if (totalNoOptions === undefined || totalNoOptions === 0) {
            toast.error('No options available.');
            return; // Prevent the action from proceeding
        }
    }

    return next(action); // Proceed with the action if conditions are met
};

export default cartMiddleware;
